import { render } from "./AdminDashboardView.vue?vue&type=template&id=63572b3c&scoped=true&ts=true"
import script from "./AdminDashboardView.vue?vue&type=script&lang=ts"
export * from "./AdminDashboardView.vue?vue&type=script&lang=ts"

import "./AdminDashboardView.vue?vue&type=style&index=0&id=63572b3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63572b3c"]])

export default __exports__